import { render, staticRenderFns } from "./ship_receipCode_dialog.vue?vue&type=template&id=397be6f9"
import script from "./ship_receipCode_dialog.vue?vue&type=script&lang=js"
export * from "./ship_receipCode_dialog.vue?vue&type=script&lang=js"
import style0 from "./ship_receipCode_dialog.vue?vue&type=style&index=0&id=397be6f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports